import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "BannerConfigViewContainer"
};
const _hoisted_2 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonDialog = _resolveComponent("ButtonDialog");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
    modelValue: $data.tab,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.tab = $event)
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.sites, site => {
      return _openBlock(), _createBlock(_component_el_tab_pane, {
        key: `site_${site.value}`,
        label: site.label,
        name: site.label
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          class: "mt12"
        }, {
          default: _withCtx(() => [_createVNode(_component_ButtonDialog, {
            "btn-id": 6,
            "btn-name": "新增Banner",
            "init-data": {
              siteId: site.value
            },
            onFresh: $options.fetchAllData
          }, null, 8, ["init-data", "onFresh"])]),
          _: 2
        }, 1024), _createVNode(_component_BatterTableDataView, {
          "table-id": 7,
          "init-query": {
            siteId: site.value
          },
          ref_for: true,
          ref: "bannerTable"
        }, {
          image: _withCtx(data => [_createElementVNode("img", {
            src: data.rowData,
            style: {
              "width": "100px"
            }
          }, null, 8, _hoisted_2)]),
          enable: _withCtx(data => [_createVNode(_component_el_switch, {
            "model-value": data.rowData,
            onChange: e => $options.changeEnableState(data.rowId, e)
          }, null, 8, ["model-value", "onChange"])]),
          _: 2
        }, 1032, ["init-query"])]),
        _: 2
      }, 1032, ["label", "name"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])]);
}